module.exports = __webpack_public_path__ + "img/sanatorio-colegiales.4ed172c8.png";